// extracted by mini-css-extract-plugin
export default {"overlay":"RatingThankYou_overlay__JNGHi","message":"RatingThankYou_message__XGLWJ","title":"RatingThankYou_title__tNP4P","subtitle":"RatingThankYou_subtitle__9EAE9"};